import { render, staticRenderFns } from "./WholesalerDefaultPriceMarkdownComponent.vue?vue&type=template&id=2c129694&"
import script from "./WholesalerDefaultPriceMarkdownComponent.vue?vue&type=script&lang=js&"
export * from "./WholesalerDefaultPriceMarkdownComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports